import type { ShallowUnwrapRef } from "@vueuse/core";

export function getCourseForView(S: ReturnType<typeof useClient>, id: string) {
  return S.from("courses")
    .select(
      `id,name,description,visit_in_order,difficulty,
       estimated_duration_hours,start_checkpoint_id,end_checkpoint_id,
       print_files ( id , name,  url ),
       course_users ( created_at, user_id, owner, write, user:users ( id, name, username ) ),
       checkpoints!checkpoints_course_id_fkey ( lat, lng, id, radius, name, description )`
    )
    .eq("id", toValue(id))
    .order("order", { referencedTable: "checkpoints", ascending: true })
    .maybeSingle();
}

export function useCourseForView(id: MaybeRefOrGetter<string>) {
  return useSupabaseQuery({
    queryKey: computed(() => ["courses", toValue(id), "view"]),
    queryFn: (S) => getCourseForView(S, toValue(id)),
  });
}

export type CourseForView = NonNullable<
  ShallowUnwrapRef<ReturnType<typeof useCourseForView>["data"]>
>;
